export default (editorState) => {
    const selection = editorState.getSelection();
    const startKey = selection.getStartKey();
    return editorState.getCurrentContent().getBlockForKey(startKey);
};
